// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function Information() {
  return (
    <MKBox component="section" py={6}>
      <Container xs={12} sx={{ position: "relative", zIndex: 2, py: 0 }}>
        <Grid
          container
          item
          md={7}
          justifyContent="center"
          mx="auto"
          textAlign="center"
          direction="column"
        >
          <MKTypography variant="h2" color="dark">
            What we do?
          </MKTypography>
          <MKTypography
            variant="body2"
            color="dark"
            mb={6}
            sx={({ breakpoints, typography: { size } }) => ({
              [breakpoints.down("md")]: {
                fontSize: size["xl"],
              },
            })}
          >
            We provide end-to-end creative services — from concept development to production and
            post-production. Our offerings include filmmaking, advertising, campaign videos, graphic
            design, animation, offline and online video editing, photography, and more. At Showthink
            Indonesia, we are committed to delivering original work driven by creativity,
            professionalism, and a deep passion for storytelling.
          </MKTypography>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
